/**
 * @generated SignedSource<<fa80e0e2ee7964d50fc216be4f43ccda>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type StorecastFocusSubjectNewInput = {
  detailItemId?: string | null;
  nodeId: string;
  scale?: number | null;
  transformX?: number | null;
  transformY?: number | null;
};
export type useSetFocusMutation$variables = {
  storecastId: string;
  subject: StorecastFocusSubjectNewInput;
};
export type useSetFocusMutation$data = {
  readonly dashboard: {
    readonly setNewFocus: {
      readonly subject: {
        readonly detailItemId: string | null;
        readonly nodeId: string;
      };
    } | null;
  };
};
export type useSetFocusMutation = {
  response: useSetFocusMutation$data;
  variables: useSetFocusMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "storecastId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "subject"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "dashboardId",
        "variableName": "storecastId"
      }
    ],
    "concreteType": "DashboardMutation",
    "kind": "LinkedField",
    "name": "dashboard",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "subject",
            "variableName": "subject"
          }
        ],
        "concreteType": "StorecastNewFocus",
        "kind": "LinkedField",
        "name": "setNewFocus",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "StorecastNewFocusSubject",
            "kind": "LinkedField",
            "name": "subject",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "nodeId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "detailItemId",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useSetFocusMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useSetFocusMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "e8acd59da6fd723032f769483fe533b5",
    "id": null,
    "metadata": {},
    "name": "useSetFocusMutation",
    "operationKind": "mutation",
    "text": "mutation useSetFocusMutation(\n  $storecastId: ID!\n  $subject: StorecastFocusSubjectNewInput!\n) {\n  dashboard(dashboardId: $storecastId) {\n    setNewFocus(subject: $subject) {\n      subject {\n        nodeId\n        detailItemId\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "cbe7651bdd4fe8b5db2665c85c77bed6";

export default node;
